import axios from 'axios';
import Cookies from 'js-cookie';
import { clearUserFromCookie } from '../hooks/useUser';
import { Message } from '../components';

let navigate;

export const setupAxiosInterceptors = (nav) => {
    navigate = nav;

    // 請求攔截器 - 自動添加 token
    axios.interceptors.request.use(
        (config) => {
            const token = Cookies.get('employeeToken');
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    // 響應攔截器 - 處理 401 錯誤
    axios.interceptors.response.use(
        (response) => response,
        (error) => {
            if (error.response?.status === 401) {
                Message('登入已過期，請重新登入', 'warning');
                // Token 失效，清除 Cookie 並重定向到登入頁
                clearUserFromCookie();
                
                if (navigate) {
                    navigate('/login');
                }
            }
            return Promise.reject(error);
        }
    );
};
